export const MAXIMUM_VISIBLE_ITEMS = 6;
export const HEIGHT_OF_ITEM = 42;
